module.exports={render:function (){var _vm=this;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "carousel slide text-xs-center",
    attrs: {
      "id": "carousel-home",
      "data-ride": "carousel",
      "data-interval": "0"
    }
  }, [_vm._h('ol', {
    staticClass: "carousel-indicators hidden-md-down"
  }, [_vm._h('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#carousel-home",
      "data-slide-to": "0"
    }
  }), " ", _vm._h('li', {
    attrs: {
      "data-target": "#carousel-home",
      "data-slide-to": "1"
    }
  }), " ", _vm._h('li', {
    attrs: {
      "data-target": "#carousel-home",
      "data-slide-to": "2"
    }
  })]), " ", _vm._h('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_vm._h('div', {
    staticClass: "carousel-item active"
  }, [_vm._h('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/static/home/slider1.jpg",
      "alt": "First slide"
    }
  }), " ", _vm._h('div', {
    staticClass: "carousel-caption"
  }, [_vm._h('h3', ["BIENVENIDOS"]), " ", _vm._h('h4', ["-"]), " ", _vm._h('p', ["Somos la plataforma online encargada ", _vm._h('br'), " de dinamizar al mercado autopartista"])])]), " ", _vm._h('div', {
    staticClass: "carousel-item"
  }, [_vm._h('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/static/home/slider2.jpg",
      "alt": "First slide"
    }
  }), " ", _vm._h('div', {
    staticClass: "carousel-caption"
  }, [_vm._h('p', ["¡Con WPO podés ser comprador y vendedor de"]), " ", _vm._h('h3', ["todo tipo de autopartes!"])])]), " ", _vm._h('div', {
    staticClass: "carousel-item"
  }, [_vm._h('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/static/home/slider3.jpg",
      "alt": "First slide"
    }
  }), " ", _vm._h('div', {
    staticClass: "carousel-caption"
  }, [_vm._h('p', ["Un espacio exclusivo para encontrar ", _vm._h('br'), " y ofrecer todo tipo de repuestos"]), " ", _vm._h('h3', ["todo a un click de distancia…"])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d8977d5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home-Slider.vue
// module id = 70
// module chunks = 1